import { render, staticRenderFns } from "./OtaSync.vue?vue&type=template&id=93efafbe&scoped=true&"
import script from "./OtaSync.vue?vue&type=script&lang=js&"
export * from "./OtaSync.vue?vue&type=script&lang=js&"
import style0 from "./OtaSync.vue?vue&type=style&index=0&id=93efafbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93efafbe",
  null
  
)

export default component.exports